import { useTranslate } from '@tolgee/react';
import { Tooltip } from 'antd';
import styled from 'styled-components';

import { CheckSvg } from '../../../assets/icons';
import { zIndexes } from '../../../utils/zIndexes';
import { IconWrapper } from '../../_atoms/IconWrapper';

const ShowFeedbackToggle = ({
  feedbackIconVisible,
  onToggle,
}: {
  feedbackIconVisible: boolean;
  onToggle: () => void;
}) => {
  const { t } = useTranslate();
  return (
    <ShowFeedbackToggleContainer>
      {feedbackIconVisible && (
        <Tooltip
          title={t('You can click here to see the feedback given to this response')}
        >
          <IconWrapper
            onClick={e => {
              e.stopPropagation();
              onToggle();
            }}
            height="16px"
            width="16px"
          >
            <CheckSvg />
          </IconWrapper>
        </Tooltip>
      )}
    </ShowFeedbackToggleContainer>
  );
};

export default ShowFeedbackToggle;

const ShowFeedbackToggleContainer = styled.div`
  z-index: ${zIndexes('PRESENTER_HIDE_RESPONSE')};
  position: absolute;
  top: 7px;
  right: 27px;
  margin: 0px !important;
`;
